/**
 * Sandbox CTA button text used across the app.
 */
export const SANDBOX_CTA_TEXT = 'Explore sandbox';
